import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { Redirect } from 'react-router-dom';
import { Creators } from './duck/actions';

import galleryClose from '../../assets/images/gallery-close.png';
import adSeparator from '../../assets/images/ad-separator.png';
import adLinkedin from '../../assets/images/ad-linkedin.png';
import AdBanner from '../common/AdBanner/AdBanner';
import { FlexContainer } from '../common/StyledComponents/FlexContainer';
import { Image } from '../common/StyledComponents/Image';
import { Title } from '../common/StyledComponents/Title';
import Slider from './Slider';
import Slide from './Slide';
import './gallery.css';

class Gallery extends Component {
  state = {
    currentIndex: 0,
    translateValue: 0
  };

  goToPrevSlide = e => {
    // console.log('e: ', e);
    // e.preventDefault;
    e.stopPropagation();
    // console.log('this.state: ', this.state);

    if (this.state.currentIndex === 0) return;

    this.setState(prevState => {
      // this.props.history.replace(`${prevState.currentIndex - 1}`);

      return {
        currentIndex: prevState.currentIndex - 1,
        translateValue: prevState.translateValue + this.slideWidth()
      };
    });

    // this.props.match.params.index = this.state.currentIndex;
  };

  goToNextSlide = () => {
    // Exiting the method early if we are at the end of the images array.
    // We also want to reset currentIndex and translateValue, so we return
    // to the first image in the array.
    if (this.state.currentIndex === this.props.galleryData.length - 1) {
      this.setState(prevState => {
        // this.props.history.replace(`0`);
        return {
          currentIndex: 0,
          translateValue: 0
        };
      });
    }

    // This will not run if we met the if condition above
    else {
      this.setState(prevState => {
        // this.props.history.replace(`${prevState.currentIndex + 1}`);
        return {
          currentIndex: prevState.currentIndex + 1,
          translateValue: prevState.translateValue + -this.slideWidth()
        };
      });
    }
  };

  slideWidth = () => {
    // return document.querySelector('.slide').clientWidth;
    return document.querySelector('.slider-wrapper').clientWidth;
  };

  componentWillMount = () => {
    // console.log('[Tags.js] componentWillMount');
    // window.scrollTo(0, 0);
    // console.log('this.props: ', this.props);
  };

  componentDidMount = () => {
    // console.log('this.props: ', this.props);
    // console.log('*** CDM ***');
    // console.log('this.props.match.params.slug: ', this.props.match.params.slug);
    // this.props.onFetchGallery(this.props.match.params.slug);
    console.log(
      'this.props.location.oldGallerySlug: ',
      this.props.location.oldGallerySlug
    );
    this.props.onFetchGallery(this.props.location.oldGallerySlug);

    if (this.props.match.params.index) {
      let index = this.props.match.params.index;
      this.setState({
        currentIndex: Number(index),
        translateValue: index * this.slideWidth() * -1
      });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    // console.log('prevProps: ', prevProps);
    // console.log('prevState: ', prevState);
    // if (prevProps.match.params.index && prevProps.match.params.index) {
    //   let index = prevProps.match.params.index;
    //   this.setState({
    //     currentIndex: index,
    //     translateValue: index * this.slideWidth() * -1
    //   });
    // }
  };

  // componentWillUpdate = (nextProps, nextState) => {
  //   if (this.props.match.params.index) {
  //     let index = this.props.match.params.index;
  //     this.setState({
  //       currentIndex: index,
  //       translateValue: index * this.slideWidth() * -1
  //     });
  //   }
  // };

  navigateAndIncreasePostCount = (postId, postSlug) => {
    // this.props.onIncreasePostCount(postId);
    // this.navigate(postSlug);
  };

  navigate = postSlug => {
    this.props.history.push(`/${postSlug}`);
  };

  render() {
    // const { match } = this.props;

    // if (!match.params.index) {
    //   return <Redirect to={`${match.url}/0`} />;
    // }
    // const { tagsPostList } = this.props;
    // console.log('this.props: ', this.props);
    // console.log('this.state: ', this.state);
    // console.log('*** Render ***');

    // console.log('this.props: ', this.props);
    return (
      <div
        className="Gallery w-100 h-100"
        style={{ background: 'rgba(0, 0, 0, 0.6)' }}
      >
        {/* Close Button Start */}

        <img
          src={galleryClose}
          alt="gallery-close"
          width="84px"
          height="84px"
          onClick={() => this.props.history.goBack()}
          style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            cursor: 'pointer'
          }}
        />

        {/* Close Button End */}

        <FlexContainer
          className="pv3"
          background="transparent"
          width="100%"
          // height="145px"
          justifycontent="center"
          alignitems="center"
          style={{ background: '#f1f1f1' }}
        >
          <AdBanner height="91px" width="730px">
            <Image
              src={adSeparator}
              width="100%"
              height="100%"
              alt="tissot ad"
            />
          </AdBanner>
        </FlexContainer>
        <FlexContainer
          className="w-100 h-100 flex justify-center"
          style={{ padding: '0 90px 70px 90px' }}
        >
          <FlexContainer
            style={{
              background: '#fff',
              width: 'calc(100vw - 90px - 90px)',
              maxWidth: '1440px',
              // height: 'calc(100vh - 123px - 70px - 70px)',
              height: '100%',
              maxHeight: '938px',
              borderRadius: '10px',
              padding: '8px'
            }}
          >
            {/* Gallery Comes here */}
            <FlexContainer
              className="flex-column"
              style={{ width: '100%', height: '100%' }}
            >
              {/* {this.props.galleryData ? ( */}
              <Slider
                images={this.props.galleryData}
                goToNextSlide={this.goToNextSlide}
                goToPrevSlide={this.goToPrevSlide}
                currentIndex={this.state.currentIndex}
                translateValue={this.state.translateValue}
              />
              {/* ) : null} */}
              <FlexContainer>
                <Title
                  className="flex justify-between w-100"
                  fontFamily="Nunito"
                  fontSize="1.25rem"
                  lineHeight="1.3"
                  color="#212121"
                  padding="1rem"
                >
                  <b>
                    Gallery (
                    {this.props.galleryData
                      ? this.props.galleryData.length
                      : ''}
                    )
                  </b>
                  {this.props.galleryData ? (
                    <b>{`${this.state.currentIndex + 1} of ${
                      this.props.galleryData.length
                    }`}</b>
                  ) : null}
                </Title>
              </FlexContainer>
              <FlexContainer className="gallery-list justify-center items-center flex-wrap">
                {this.props.galleryData
                  ? this.props.galleryData.map((image, index) => {
                      // console.log('image: ', image);
                      return (
                        <div
                          key={image.ID}
                          style={{
                            margin: '0.5rem',
                            width: '100px',
                            height: '62px'
                          }}
                        >
                          <Slide
                            image={image.sizes.thumbnail}
                            // // alt={index}
                            // width="100px"
                            // height="62px"
                            // // style={{
                            // //   margin: '0.5rem'
                            // // }}
                            // style={{ margin: '0.5rem' }}
                          />
                        </div>
                      );
                    })
                  : null}
              </FlexContainer>
            </FlexContainer>
            <FlexContainer
              className="flex-column side-bar"
              style={{ padding: '0 0 0 1rem' }}
            >
              <Title
                className="pt4 w-100"
                fontFamily="Montserrat"
                fontSize="1.125rem"
                lineHeight="1.67"
                color="#080808"
                style={{ maxWidth: '300px' }}
              >
                {this.props.galleryData &&
                this.props.galleryData[this.state.currentIndex]
                  ? `#${this.state.currentIndex + 1}. ${
                      this.props.galleryData[this.state.currentIndex].title
                    }`
                  : null}
              </Title>
              <AdBanner
                className="relative top-2"
                height="250px"
                width="300px"
                margin="0 0 14px 0"
              >
                <Image
                  src={adLinkedin}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  console.log('state.gallery: ', state.gallery);
  return {
    loading: state.authorInfo.loading,
    galleryData: state.gallery.oldGalleryData
  };
};

const mapDispatchToProps = dispatch => ({
  onFetchGallery: slug => dispatch(Creators.fetchOldGallery(slug))
  // onIncreasePostCount: postId => dispatch(Creators.increasePostCount(postId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Gallery);
